(function($) {
    'use strict';

    const RADIUS_FALLBACK_KM = 30;
    const SEARCH_DEBOUNCE_MS = 300;
    const EARTH_RADIUS_KM = 6371;
    const SUGGESTIONS_MIN_CHARS = 3;
    const SUGGESTIONS_MAX_COUNT = 5;

    const ArchiveMaze = {
        init: function() {
            this.$container = $('.archive-maze-main');
            if (!this.$container.length) return;

            this.$mapContainer = $('#maze-map');
            this.$listContainer = $('#maze-list');
            this.$searchInput = $('#maze-search-input');

            this.mazes = this.$container.data('mazes') || [];
            this.defaultMarker = '/wp-content/themes/popcorn_corpo/assets/img/marker.svg';
            this.markerNormalUrl = this.$container.data('marker-normal');
            this.markerActiveUrl = this.$container.data('marker-active');
            this.communesUrl = this.$container.data('communes-url') || '';
            this.radiusKm = parseFloat(this.$container.data('radius-km')) || RADIUS_FALLBACK_KM;

            this.map = null;
            this.markers = [];
            this.activeMarker = null;
            this.originMarker = null;

            this.communes = null;
            this.communesPromise = null;
            this.searchTimer = null;

            this.initMap();
            this.renderList(this.mazes);
            this.initSuggestions();
            this.bindEvents();
        },

        initSuggestions: function() {
            const $search = this.$container.find('.maze-search');
            if (!$search.length) return;
            this.$suggestions = $('<ul class="maze-search__suggestions" role="listbox" hidden></ul>');
            $search.append(this.$suggestions);
        },

        initMap: function() {
            if (!this.$mapContainer.length || typeof L === 'undefined') return;

            this.map = L.map('maze-map', {
                scrollWheelZoom: false
            }).setView([46.2276, 2.2137], 6); // Centré sur la France par défaut

            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            }).addTo(this.map);

            this.customIconNormal = L.icon({
                iconUrl: this.markerNormalUrl || this.defaultMarker,
                iconSize: [40, 40],
                iconAnchor: [20, 50],
                popupAnchor: [0, -50]
            });

            this.customIconActive = L.icon({
                iconUrl: this.markerActiveUrl || this.defaultMarker,
                iconSize: [40, 40],
                iconAnchor: [20, 50],
                popupAnchor: [0, -50]
            });

            this.customIconDefault = L.icon({
                iconUrl: this.defaultMarker,
                iconSize: [40, 40],
                iconAnchor: [20, 50],
                popupAnchor: [0, -50]
            });

            this.addMarkers(this.mazes);

            if (this.markers.length > 0) {
                const group = new L.featureGroup(this.markers.map(m => m.leafletMarker));
                this.map.fitBounds(group.getBounds().pad(0.1));
            }
        },

    normalizeCoordinate: function(value) {
      if (value === null || value === undefined || value === '') {
        return null;
      }

      const normalized = typeof value === 'string'
        ? value.replace(',', '.').trim()
        : value;
      const num = Number(normalized);

      return Number.isFinite(num) ? num : null;
    },

    isValidCoordinate: function(lat, lng) {
      return (
        Number.isFinite(lat) &&
        Number.isFinite(lng) &&
        lat >= -90 && lat <= 90 &&
        lng >= -180 && lng <= 180
      );
    },

    getValidMazes: function(mazes) {
      return (mazes || []).filter(maze => {
        const lat = this.normalizeCoordinate(maze.lat);
        const lng = this.normalizeCoordinate(maze.lng);
        return this.isValidCoordinate(lat, lng);
      });
		},

        addMarkers: function(mazes) {
            // Nettoyer les marqueurs existants
            this.markers.forEach(m => this.map.removeLayer(m.leafletMarker));
            this.markers = [];

            mazes.forEach(maze => {
        const lat = this.normalizeCoordinate(maze.lat);
        const lng = this.normalizeCoordinate(maze.lng);

        if (!this.isValidCoordinate(lat, lng)) {
          console.warn('[ArchiveMaze] Coordonnées invalides ignorées', maze);
          return;
        }

        const marker = L.marker([lat, lng], { icon: this.customIconNormal });
                const addressHtml = maze.address ? maze.address.replace(/<br\s*\/?>/gi, '\n').replace(/\r\n|\r|\n/g, '\n').replace(/\n+/g, '<br>') : '';

                const popupContent = `
                    <div class="maze-popup">
                        <h3 class="h4">${maze.city}</h3>
                        <div class="maze-status">
                            <span class="maze-status__color-bullet" style="--status-color: ${maze.status.color}"></span>
                            <div class="maze-status__label">${maze.status.label}</div>
                        </div>
                        <address class="maze-popup__address">${addressHtml}</address>
                        <a href="${maze.permalink}" class="btn is-primary-beige is-small">Découvrir le labyrinthe</a>
                    </div>
                `;

                marker.bindPopup(popupContent);

                marker.on('click', () => {
                    this.setActiveMarker(marker);
                });

                marker.on('popupclose', () => {
                    if (this.activeMarker === marker) {
                        marker.setIcon(this.customIconNormal);
                        this.activeMarker = null;
                    }
                });

                marker.addTo(this.map);
                this.markers.push({
                    data: maze,
                    leafletMarker: marker
                });
            });
        },

        setActiveMarker: function(marker) {
            if (this.activeMarker) {
                this.activeMarker.setIcon(this.customIconNormal);
            }
            this.activeMarker = marker;
            marker.setIcon(this.customIconActive);
        },

        renderList: function(mazes) {
            this.$listContainer.empty();

			const validMazes = this.getValidMazes(mazes);

			if (validMazes.length === 0) {
                this.$listContainer.append('<p class="maze-list__empty">Aucun labyrinthe trouvé pour cette recherche.</p>');
                return;
            }

			validMazes.forEach(maze => {
                const addressHtml = maze.address ? maze.address.replace(/<br\s*\/?>/gi, '\n').replace(/\r\n|\r|\n/g, '\n').replace(/\n+/g, '<br>') : '';
                const bookingBtn = maze.bookingUrl
                    ? `<a href="${maze.bookingUrl}" class="btn is-primary is-mini is-txt-font maze-item__btn" target="_blank" rel="noopener" onclick="event.stopPropagation()">${'Réserver une activité'}</a>`
                    : '';
                const $item = $(`
                    <div class="maze-item" data-id="${maze.id}">
                        <div class="maze-item__content">
                            <div class="maze-item__info">
                                <h3 class="h4">${maze.city}</h3>
                                <div class="maze-status">
                                    <span class="maze-status__color-bullet" style="--status-color: ${maze.status.color}"></span>
                                    <div class="maze-status__label">${maze.status.label}</div>
                                </div>
                                <address class="maze-item__address">${addressHtml}</address>
                            </div>
                            <div class="maze-item__actions">
                                <a href="${maze.permalink}" class="btn is-primary-beige is-mini is-txt-font maze-item__btn" onclick="event.stopPropagation()">${'Découvrir le labyrinthe'}</a>
                                ${bookingBtn}
                            </div>
                        </div>
                    </div>
                `);

                $item.on('click', () => {
                    const markerObj = this.markers.find(m => m.data.id === maze.id);
                    if (markerObj) {
                        this.map.setView(markerObj.leafletMarker.getLatLng(), 13);
                        markerObj.leafletMarker.openPopup();
                        this.setActiveMarker(markerObj.leafletMarker);
                    }
                });

                this.$listContainer.append($item);
            });
        },

        // Doit reproduire la normalisation appliquée côté PHP (build-communes.php) :
        // NFD → suppression des diacritiques, minuscules, apostrophes/tirets → espaces,
        // suppression du reste de la ponctuation, espaces multiples → simple espace.
        normalizeQuery: function(value) {
            if (typeof value !== 'string') return '';
            return value
                .normalize('NFD')
                .replace(/[̀-ͯ]/g, '')
                .toLowerCase()
                .replace(/['’`]/g, ' ')
                .replace(/[-_]/g, ' ')
                .replace(/[^a-z0-9 ]+/g, '')
                .replace(/\s+/g, ' ')
                .trim();
        },

        loadCommunes: function() {
            if (this.communes) return Promise.resolve(this.communes);
            if (this.communesPromise) return this.communesPromise;
            if (!this.communesUrl) return Promise.resolve(null);

            this.communesPromise = fetch(this.communesUrl, { credentials: 'same-origin' })
                .then(response => {
                    if (!response.ok) throw new Error('HTTP ' + response.status);
                    return response.json();
                })
                .then(data => {
                    this.communes = Array.isArray(data) ? data : null;
                    return this.communes;
                })
                .catch(err => {
                    console.error('[ArchiveMaze] Chargement communes échoué', err);
                    this.communesPromise = null;
                    return null;
                });

            return this.communesPromise;
        },

        findCommune: function(normalizedQuery) {
            if (!normalizedQuery || !this.communes) return null;

            let startsWithMatch = null;
            for (let i = 0; i < this.communes.length; i++) {
                const entry = this.communes[i];
                const name = entry[1];
                if (name === normalizedQuery) {
                    return entry;
                }
                if (!startsWithMatch && name.startsWith(normalizedQuery)) {
                    startsWithMatch = entry;
                }
            }
            if (startsWithMatch) return startsWithMatch;

            for (let i = 0; i < this.communes.length; i++) {
                if (this.communes[i][1].includes(normalizedQuery)) {
                    return this.communes[i];
                }
            }
            return null;
        },

        findSuggestions: function(normalizedQuery, max) {
            if (!normalizedQuery || !this.communes) return [];

            const limit = max || SUGGESTIONS_MAX_COUNT;
            const starts = [];
            const contains = [];

            for (let i = 0; i < this.communes.length; i++) {
                const entry = this.communes[i];
                const name = entry[1];
                if (name.startsWith(normalizedQuery)) {
                    starts.push(entry);
                    if (starts.length >= limit) break;
                }
            }
            if (starts.length >= limit) return starts;

            for (let i = 0; i < this.communes.length && (starts.length + contains.length) < limit; i++) {
                const entry = this.communes[i];
                const name = entry[1];
                if (!name.startsWith(normalizedQuery) && name.includes(normalizedQuery)) {
                    contains.push(entry);
                }
            }
            return starts.concat(contains);
        },

        renderSuggestions: function(items) {
            if (!this.$suggestions) return;
            this.$suggestions.empty();

            if (!items || items.length === 0) {
                this.hideSuggestions();
                return;
            }

            items.forEach(entry => {
                const $item = $('<li class="maze-search__suggestion" role="option" tabindex="-1"></li>')
                    .text(entry[0]);
                $item.on('mousedown', (e) => {
                    // mousedown plutôt que click pour battre le blur de l'input.
                    e.preventDefault();
                    this.selectSuggestion(entry);
                });
                this.$suggestions.append($item);
            });

            this.$suggestions.prop('hidden', false);
        },

        hideSuggestions: function() {
            if (!this.$suggestions) return;
            this.$suggestions.prop('hidden', true).empty();
        },

        selectSuggestion: function(entry) {
            if (!entry) return;
            this.$searchInput.val(entry[0]);
            this.hideSuggestions();
            clearTimeout(this.searchTimer);
            this.applyRadiusFilter(entry[0]);
        },

        updateSuggestions: function(rawQuery) {
            const normalized = this.normalizeQuery((rawQuery || '').trim());
            if (normalized.length < SUGGESTIONS_MIN_CHARS) {
                this.hideSuggestions();
                return;
            }

            this.loadCommunes().then(communes => {
                const currentNorm = this.normalizeQuery((this.$searchInput.val() || '').trim());
                if (currentNorm !== normalized) return;
                if (!communes) {
                    this.hideSuggestions();
                    return;
                }
                const items = this.findSuggestions(normalized, SUGGESTIONS_MAX_COUNT);
                this.renderSuggestions(items);
            });
        },

        haversineKm: function(lat1, lng1, lat2, lng2) {
            const toRad = deg => deg * Math.PI / 180;
            const dLat = toRad(lat2 - lat1);
            const dLng = toRad(lng2 - lng1);
            const a = Math.sin(dLat / 2) ** 2
                + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
            return 2 * EARTH_RADIUS_KM * Math.asin(Math.min(1, Math.sqrt(a)));
        },

        updateMarkersVisibility: function(filtered) {
            this.markers.forEach(m => {
                const visible = filtered.some(f => f.id === m.data.id);
                if (visible && !this.map.hasLayer(m.leafletMarker)) {
                    m.leafletMarker.addTo(this.map);
                } else if (!visible && this.map.hasLayer(m.leafletMarker)) {
                    this.map.removeLayer(m.leafletMarker);
                }
            });
        },

        setOriginMarker: function(lat, lng) {
            if (!this.map || !this.customIconDefault) return;
            if (this.originMarker) {
                this.map.removeLayer(this.originMarker);
            }
            this.originMarker = L.marker([lat, lng], {
                icon: this.customIconDefault,
                interactive: false,
                keyboard: false
            }).addTo(this.map);
        },

        clearOriginMarker: function() {
            if (this.originMarker && this.map) {
                this.map.removeLayer(this.originMarker);
            }
            this.originMarker = null;
        },

        fitMapToFiltered: function(filtered, hasQuery) {
            if (hasQuery && filtered.length > 0) {
                const visibleMarkers = this.markers.filter(m => this.map.hasLayer(m.leafletMarker));
                const layers = visibleMarkers.map(m => m.leafletMarker);
                if (this.originMarker) {
                    layers.push(this.originMarker);
                }
                if (layers.length > 0) {
                    const group = new L.featureGroup(layers);
                    this.map.fitBounds(group.getBounds().pad(0.2));
                }
            } else if (!hasQuery && this.markers.length > 0) {
                const group = new L.featureGroup(this.markers.map(m => m.leafletMarker));
                this.map.fitBounds(group.getBounds().pad(0.1));
            }
        },

        showAllMazes: function() {
            this.clearOriginMarker();
            this.renderList(this.mazes);
            this.updateMarkersVisibility(this.mazes);
            this.fitMapToFiltered(this.mazes, false);
        },

        showNoResults: function() {
            this.clearOriginMarker();
            this.$listContainer.empty().append(
                '<p class="maze-list__empty">Aucun labyrinthe trouvé pour cette recherche.</p>'
            );
            this.updateMarkersVisibility([]);
        },

        applyRadiusFilter: function(rawQuery) {
            const query = (rawQuery || '').trim();
            if (query === '') {
                this.showAllMazes();
                return;
            }

            const normalized = this.normalizeQuery(query);
            if (normalized === '') {
                this.showAllMazes();
                return;
            }

            this.loadCommunes().then(communes => {
                // L'utilisateur peut avoir continué à taper : on revérifie l'état courant.
                const currentRaw = this.$searchInput.val();
                const currentNorm = this.normalizeQuery((currentRaw || '').trim());
                if (currentNorm !== normalized) {
                    return;
                }

                if (!communes) {
                    this.showNoResults();
                    return;
                }

                const commune = this.findCommune(normalized);
                if (!commune) {
                    this.showNoResults();
                    return;
                }

                const originLat = commune[2];
                const originLng = commune[3];
                const radius = this.radiusKm;

                const filtered = this.mazes.filter(maze => {
                    const lat = this.normalizeCoordinate(maze.lat);
                    const lng = this.normalizeCoordinate(maze.lng);
                    if (!this.isValidCoordinate(lat, lng)) return false;
                    return this.haversineKm(originLat, originLng, lat, lng) <= radius;
                });

                if (filtered.length === 0) {
                    this.showNoResults();
                    return;
                }

                this.setOriginMarker(originLat, originLng);
                this.renderList(filtered);
                this.updateMarkersVisibility(filtered);
                this.fitMapToFiltered(filtered, true);
            });
        },

        bindEvents: function() {
            // Précharge le JSON dès le premier focus pour éviter la latence à la frappe.
            this.$searchInput.one('focus', () => {
                this.loadCommunes();
            });

            this.$searchInput.on('input', (e) => {
                const value = $(e.target).val();
                this.updateSuggestions(value);
                clearTimeout(this.searchTimer);
                this.searchTimer = setTimeout(() => {
                    this.applyRadiusFilter(value);
                }, SEARCH_DEBOUNCE_MS);
            });

            this.$searchInput.on('focus', () => {
                this.updateSuggestions(this.$searchInput.val());
            });

            this.$container.find('.maze-search__submit').on('click', () => {
                this.hideSuggestions();
                clearTimeout(this.searchTimer);
                this.applyRadiusFilter(this.$searchInput.val());
            });

            this.$searchInput.on('keydown', (e) => {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    this.hideSuggestions();
                    clearTimeout(this.searchTimer);
                    this.applyRadiusFilter(this.$searchInput.val());
                } else if (e.key === 'Escape') {
                    this.hideSuggestions();
                }
            });

            $(document).on('mousedown.archiveMaze', (e) => {
                if (!this.$suggestions) return;
                const $target = $(e.target);
                if (
                    !$target.closest('.maze-search__suggestions').length &&
                    !$target.is(this.$searchInput)
                ) {
                    this.hideSuggestions();
                }
            });
        }
    };

    $(document).ready(function() {
        ArchiveMaze.init();
    });

})(jQuery);
